module.exports = __webpack_public_path__ + "img/fvdl-logo.e17151fd.svg";